module.exports = __webpack_public_path__ + "media/images/tnt-white-f08da881.png";